import { lazy } from 'react'

export const KetoDiet = lazy(() => import('./KetoDiet'))
